var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconToolBarWellnessCheckIn(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Icon_ToolBar_WellnessCheckIn"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.2326 2.77271H6.77246C4.56332 2.77271 2.77246 4.56356 2.77246 6.7727V54.2272C2.77246 56.4364 4.56332 58.2272 6.77246 58.2272H54.227C56.4361 58.2272 58.227 56.4364 58.227 54.2273V19.7203L52.227 26.0631V52.2272H8.77246V8.77271H41.6941L47.2326 2.77271ZM57.8064 4.98536L56.361 3.38888C56.9767 3.77796 57.4788 4.33043 57.8064 4.98536Z",
    fill: "#8F84DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M54.2327 2.77271L50.9902 6.18715L27.6792 30.8481L23.8727 27.1491L20.4893 23.7346L13.8633 30.4213L17.2468 33.8357L24.2957 40.9492L27.5382 44.3636L30.9217 40.9492L57.6162 12.8738L60.9996 9.45933L54.2327 2.77271Z",
    fill: "#8F84DE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconToolBarWellnessCheckIn);
export default __webpack_public_path__ + "static/media/Icon_ToolBar_WellnessCheckIn.084ea03e79e9a41c026428489cb52d0c.svg";
export { ForwardRef as ReactComponent };